var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_directbox-notif",
    "data-name": "vuesax/twotone/directbox-notif",
    transform: "translate(-172 -186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "directbox-notif"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4,0C0,0,0,1.79,0,4V5c0,2.76,0,5,5,5h8c4,0,5-2.24,5-5V4c0-2.21,0-4-4-4a2.361,2.361,0,0,0-1.8.6L11.18,1.68a3,3,0,0,1-4.37,0L5.8.6A2.361,2.361,0,0,0,4,0Z",
    transform: "translate(175 198)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14,10V4c0-2.21,0-4-4-4H4C0,0,0,1.79,0,4v6",
    transform: "translate(177 188)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H3.33",
    transform: "translate(182.55 195.23)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H5",
    transform: "translate(181.72 192.23)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 186)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBoard);
export default __webpack_public_path__ + "static/media/noticeBoard.91be59feed417d5adb1dbbe1a13f57d3.svg";
export { ForwardRef as ReactComponent };